import React from 'react'
import About from '../About/About'
import Footer from '../Footer/Footer'
import Menu from '../Menu/Menu'
import MyBlogs from '../MyBlogs/MyBlogs'
import PersonalDetail from '../personalDetail/PersonalDetail'
import Projects from '../Projects/Projects'
import './Home.css'

const Home = () => {
  return (
    <div id='home'>
      <div className='left-main'>
        <div className='left-part'>
          <PersonalDetail></PersonalDetail>
        </div>
      </div>
      <div className='right-part'>
        <Menu></Menu>
        <About></About>
        <Projects></Projects>
        {/* <MyBlogs></MyBlogs> */}
        <Footer></Footer>
      </div>
    </div>
  )
}

export default Home
